document.addEventListener('turbolinks:before-cache', () => {
  document.querySelectorAll('[data-controller="notice"]').forEach((e) => e.remove());
  document.querySelectorAll('.notyf').forEach((e) => e.remove());
  document.querySelectorAll('.modal.is-open').forEach((e) => e.classList.remove('is-open'));
  document.querySelectorAll('.slide-menu--open').forEach((e) => e.classList.remove('slide-menu--open'));
  document.querySelectorAll('[data-modal-show-on-load-value="true"]').forEach((e) => e.remove());
});
